module.exports = __webpack_public_path__ + "img/business_sheet_bg.4bcb1391.png";